export const isKioskCustomerSelector = state => state.user.isKioskCustomer;

export const isUserFetchedSelector = state => state.user.isFetched;

export const getEcommerceUser = state => state.user;

export const isUserMedical = state => state.user.customerType === "MEDICAL";

export const isAdult = state => state.user.adult;



// WEBPACK FOOTER //
// ./src/selectors/userSelectors.js